export default __webpack_public_path__ + "static/media/failed-report.83d4a3ec.png";